import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Table, Tag, Dropdown, Menu, Button } from "antd";
import translate from "../../../shared/utils/translations";

const EmailList = ({ sendEmail }) => {
  let navigate = useNavigate();

  const columns = [
    {
      title: translate("From"),
      dataIndex: "from",
      key: "from",
      render: (item) => (
        <>
          <div className="column_info">{translate("From")}</div>
          {item}
        </>
      ),
    },
    {
      title: translate("To"),
      dataIndex: "to",
      key: "to",
      render: (item) => (
        <>
          <div className="column_info">{translate("To")}</div>
          {item}
        </>
      ),
    },
    {
      title: translate("Subject"),
      dataIndex: "subject",
      key: "subject",
      render: (item) => (
        <>
          <div className="column_info">{translate("Subject")}</div>
          {item}
        </>
      ),
    },
    {
      title: translate("Date"),
      dataIndex: "date",
      key: "date",
      render: (item) => (
        <>
          <div className="column_info">{translate("Date")}</div>
          {item}
        </>
      ),
    },
    {
      title: translate("Status"),
      key: "status",
      dataIndex: "status",
      render: (status) => (
        <>
        <div className="column_info">{translate("Status")}</div>
          <Tag className={status === "sent" ? "default__tag" : "error__tag"}>
            {status === "sent" ? translate("Sent") : translate("Draft")}
          </Tag>
        </>
      ),
    },
    {
      title: translate("Action"),
      key: "action",
      className: "table_actin",
      render: (text, row) => (
        <>
          <div className="column_info">{translate("Action")}</div>
          {row.status === "sent" ? (
            <></>
          ) : (
            <button
              onClick={() => sendEmail()}
              className="button-small button-stroke question__button app"
            >
              {translate("Send Draft")}
            </button>
          )}
        </>
      ),
    },
  ];

  const data = [
    {
      key: "1",
      from: "sales@kepicker.com",
      to: "All Users",
      subject: "Kepicker Lansman",
      date: "02.03.2024",
      status: "sent",
    },
    {
      key: "2",
      from: "sales@kepicker.com",
      to: "Just Market Connected",
      subject: "Kepicker Lansman",
      date: "02.03.2024",
      status: "draft",
    },
    {
      key: "3",
      from: "sales@kepicker.com",
      to: "All Free",
      subject: "Kepicker Lansman",
      date: "02.03.2024",
      status: "sent",
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          locale: {
            items_per_page: translate("Page"),
          },
          position: ["top", "bottom"],
        }}
        className="card_m"
      />
    </>
  );
};

export default EmailList;
